export default __webpack_public_path__ + "c375d25bc41f519d939158aadbba5631.png";